//  prettier-ignore
export const config = () => {
  let APPID;
  let AppSECRET;
  let BASE_URL;
  let MEET_RESTAPI_URL;
  let CALL_SERVER_WSS_URL;
  let VIDEO_CALL_SERVER_WSS_URL;
  let CALL_SERVER_STUN_URL;
  let VIDEO_CALL_SERVER_STUN_URL;
  let VIDEO_CALL_SERVER_STUN_URL_TH;
  let VIDEO_CALL_SERVER_STUN_URL_DDCL;
  let VIDEO_CALL_SERVER_V6_STUN_URL;
  let VIDEO_CALL_SERVER_V6_STUN_URL_DDCL;
  let VIDEO_CALL_SERVER_V6_STUN_URL_TH;
  let VIDEO_CALL_SERVER_STUN_USERNAME = "admin";
  let VIDEO_CALL_SERVER_STUN_PASSWORD = "system123";
  let CORESERVICE_URL;
  let LOGIN_API;
  let UPLOAD_MEETING_FILES;
  let CALLSERVICE_URL;
  let EMAILSERVICE_URL;
  let SMSSERVICE_URL;
  let REPORTSERVICE_URL;
  let SOCKET_URL;
  let LIVECHATSERVICEURL;
  let CALL_SERVER_USER_AGENT = "CCAAS:BROWSER";
  let VIDEO_SERVER_USER_AGENT = "URWEB:VIDEO";
  let CALL_SERVER_STUN_USERNAME = "admin";
  let CALL_SERVER_STUN_PASSWORD = "system123";
  let DOMAIN_NAME_PORT = "5060";
  let MYACCOUNT = "";
  let LOG_OUT_API = "";
  let TICKETSERVICE_URL;
  let MYACCOUNTSERVICE_URL;
  let PRICING_URL;
  let CONNECTORS_API_BASE_URL = "https://qaccaasapi.worktual.co.uk/connector";
  let DEVELOPER_APP_BASE_URL = 'https://qaapi.worktual.co.uk/services/v1'
  let ZENDESK_SUPPORT_CLIENT_ID = "zdg-worktual_ucaas_for_zendesk_support"
  let ZENDESK_SUPPORT_SCOPES = "tickets:read write users:read write organizations:write read"
  let BOT_URL = "";
  let SMS_DID = ''
  let WHATSAPP_URL = ''
  let FACEBOOK_URL = ''
  let INSTAGRAM_URL = ''
  let CHATBOT_URL = ''
  let SOCIALMEDIA_URL;
  let SHOPIFY_CLIENT_ID = 'b527b305f85fcc1c8be953ca7ecc2c38'
  let CRM_URL = "";
  let CCAAS_WHATSAPP_URL = '';
  let MYACCOUNT_PROFILE = '';
  let WHATSAPP_CONF_URL = '';
  let BUSINESS_WHATSAPP_CONF_URL = '';
  let APPOINTMENT_BOOKING_URL = ''
  let BOT_SCRIPT_URL = '';
  let FACEBOOK_CONFIG_ID = '1109736967317755';
  let FACEBOOK_APP_ID = "2792648964217350";
  let GET_ALL_TEMPLATES_URL = "";
  let GET_TEMPLATE_URL = "";
  let BOTH_TYPE_CONTACT_SYNC = ['salesforce', 'HubSpot', 'dynamics', 'zoho', 'zendesk sell', 'zendesk support', 'pipedrive', 'shopify', 'wix', 'bigcommerce', 'magento', 'xero']
  let DASHBOARD_AISUMMARY_AGENTDASH = "";
  let DASHBOARD_AISUMMARY_AGENTDASH_RECOM = "";
  let DASHBOARD_AISUMMARY_MAINDASH = "";
  let DASHBOARD_AISUMMARY_MAINDASH_RECOM = "";
  let DASHBOARD_AISUMMARY_CAMPAIGNDASH = "";
  let DASHBOARD_AISUMMARY_CAMPAIGNDASH_RECOM = "";
  let FACE_DETECTION;
  let FACE_UPLOAD_IMAGE;
  let FACE_RECOGNITION;
  let DOC_UPLOAD_EXTRACT;
  let DOC_VERIFICATION;
  let VERIFICATION_DELETE;
  let TTS = "https://nlp.worktual.co.uk/tts";
  let PRIVIOUS_CHAT_SUMMARY = "https://scraping.worktual.co.uk/previous_chat_summary";
  let AGENT_SUMMARIZE_CONVO = "";
  let NLP_DNS = "https://nlpccaas.worktual.co.uk";
  if (process.env.REACT_APP_ENV === "development") {
    //stage
    // APPID = "259054";
    // AppSECRET = "w87rfoBjav";
    // BASE_URL = "http://localhost:5008";
    //qa 
    APPID = "844239";
    AppSECRET = "kU9IPc0C65";
    MEET_RESTAPI_URL = "https://stageccaasapi.worktual.co.uk/core_service";
    BASE_URL = "https://stageccaasapi.worktual.co.uk"
    CORESERVICE_URL = "https://stageccaasapi.worktual.co.uk/core_service/v1";
    SOCIALMEDIA_URL = "https://stageccaasapi.worktual.co.uk/socialmediaService/v1";
    EMAILSERVICE_URL = "https://stageccaasapi.worktual.co.uk/emailService/v1";
    SMSSERVICE_URL = "https://stageccaasapi.worktual.co.uk/smsService/v1";
    // LOGIN_API = "https://stageccaasapi.worktual.co.uk/ccaasAuth/v1/token/create_jwt";
    LOGIN_API = "https://qaurapi.worktual.co.uk/urauth/v1/token/create_jwt";
    // CALLSERVICE_URL = "http://localhost:5007/callservice/v1";
    CALLSERVICE_URL = "https://stageccaasapi.worktual.co.uk/callservice/v1";
    REPORTSERVICE_URL = "https://stageccaasapi.worktual.co.uk/reports_service/v1";
    LIVECHATSERVICEURL = "https://stageurapi.unifiedring.co.uk/vectone-myaccount/v1/user";
    CALL_SERVER_WSS_URL = "wss://testsgw15.worktual.co.uk:57344";
    CALL_SERVER_STUN_URL = "turn:audioturnv4.worktual.co.uk:3478";
    MYACCOUNT = 'https://stage-myaccount.worktual.co.uk/';
    LOG_OUT_API = "https://qaurapi.worktual.co.uk/urauth/v1/token/logout";
    TICKETSERVICE_URL = "https://ticketingsystem.worktual.co.uk/ticketing-system/v1";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
    BOT_URL = "https://qachatbot.worktual.co.uk";
    SMS_DID = "https://stagedid.worktual.co.uk/did/v1";
    WHATSAPP_URL = "https://stagedid.worktual.co.uk/whatsapp/v1";
    PRICING_URL = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
    FACEBOOK_URL = "https://stagedid.worktual.co.uk/fb";
    INSTAGRAM_URL = "https://stagedid.worktual.co.uk/ig";
    CRM_URL = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1/";
    CCAAS_WHATSAPP_URL = "https://stageccaasapi.worktual.co.uk/whatsappService/v1";
    WHATSAPP_CONF_URL = "https://stageccaasapi.worktual.co.uk/metawhatsapp";
    BUSINESS_WHATSAPP_CONF_URL = "https://stagedid.worktual.co.uk/businesswhatsapp";
    APPOINTMENT_BOOKING_URL = "https://qabookingapi.worktual.co.uk/booking_service/v1"
    GET_ALL_TEMPLATES_URL = "https://stagedid.worktual.co.uk/whatsapp/v1/wca/getTemplates";
    GET_TEMPLATE_URL = "https://stagedid.worktual.co.uk/whatsapp/v1/wca/getTemplateByName";
    DASHBOARD_AISUMMARY_AGENTDASH = "https://qaaichat.worktual.co.uk/qa_agent_dashboard";
    DASHBOARD_AISUMMARY_AGENTDASH_RECOM = "https://qaaichat.worktual.co.uk/qa_agent_dashboard_recommendation";
    DASHBOARD_AISUMMARY_MAINDASH = "https://qaaichat.worktual.co.uk/qa_main_dashboard";
    DASHBOARD_AISUMMARY_MAINDASH_RECOM = "https://qaaichat.worktual.co.uk/qa_main_dashboard_recommendation";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH = "https://nlp.worktual.co.uk/qa_outbound_callblast";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH_RECOM = "https://nlp.worktual.co.uk/qa_outbound_recommendation";
    TTS = "https://nlp.worktual.co.uk/tts";
    PRIVIOUS_CHAT_SUMMARY = "https://scraping.worktual.co.uk/previous_chat_summary";
  } else if (process.env.REACT_APP_ENV === "production") {
    //APPID = "773040";
    //AppSECRET = "EEnQKXFm4A";
    APPID = "844239";
    AppSECRET = "kU9IPc0C65";
    BASE_URL = "https://ccaasapi.worktual.co.uk";
    //CORESERVICE_URL = "http://localhost:3002/core_service/v1";
    CORESERVICE_URL = "https://ccaasapi.worktual.co.uk/core_service/v1";
    SOCIALMEDIA_URL = "https://ccaasapi.worktual.co.uk/socialmediaService/v1";
    MEET_RESTAPI_URL = "https://ccaasapi.worktual.co.uk/core_service";
    //  LOGIN_API = "https://ccaasapi.worktual.co.uk/ccaasAuth/v1/token/create_jwt";
    EMAILSERVICE_URL = "https://ccaasapi.worktual.co.uk/emailService/v1";
    SMSSERVICE_URL = "https://ccaasapi.worktual.co.uk/smsService/v1";
    CALLSERVICE_URL = "https://ccaasapi.worktual.co.uk/callservice/v1";
    // CALLSERVICE_URL = "http://localhost:5007/callservice/v1";
    // REPORTSERVICE_URL = "http://localhost:5002/reports_service/v1";
    REPORTSERVICE_URL = "https://ccaasapi.worktual.co.uk/reports_service/v1";
    LIVECHATSERVICEURL = "https://stageurapi.unifiedring.co.uk/vectone-myaccount/v1/user";
    CALL_SERVER_WSS_URL = "wss://audiosgwth.worktual.co.uk:57344";
    VIDEO_CALL_SERVER_WSS_URL = "wss://videosgwth.worktual.co.uk:57344";
    CALL_SERVER_STUN_URL = "turns:audioturnv4.worktual.co.uk:443";
    VIDEO_CALL_SERVER_STUN_URL = 'turn:audioturnv4.worktual.co.uk:3478';
    VIDEO_CALL_SERVER_STUN_URL_DDCL = "turn:audioturnv4ddcl.worktual.co.uk:3478";
    VIDEO_CALL_SERVER_STUN_URL_TH = "turn:audioturnv4th.worktual.co.uk:3478";
    VIDEO_CALL_SERVER_V6_STUN_URL = 'turn:audioturnv6.worktual.co.uk:3478';
    VIDEO_CALL_SERVER_V6_STUN_URL_DDCL = 'turn:audioturnv6ddcl.worktual.co.uk:3478';
    VIDEO_CALL_SERVER_V6_STUN_URL_TH = 'turn:audioturnv6th.worktual.co.uk:3478';
    MYACCOUNT = 'https://myaccount.worktual.co.uk'
    LOG_OUT_API = 'https://urapi.worktual.co.uk/urauth/v1/token/logout'
    LOGIN_API = "https://urapi.worktual.co.uk/urauth/v1/token/create_jwt";
    TICKETSERVICE_URL = "https://ticketingsystem.worktual.co.uk/ticketing-system/v1";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    BOT_URL = "https://botclient.worktual.co.uk";
    CONNECTORS_API_BASE_URL = 'https://ccaasapi.worktual.co.uk/connector'
    DEVELOPER_APP_BASE_URL = 'https://api.worktual.co.uk/services/v1'
    ZENDESK_SUPPORT_CLIENT_ID = "zdg-worktual_ucaas_for_zendesk_support"
    ZENDESK_SUPPORT_SCOPES = "tickets:read write users:read write organizations:write read"
    SMS_DID = "https://did.worktual.co.uk/did/v1";
    WHATSAPP_URL = "https://did.worktual.co.uk/whatsapp/v1";
    PRICING_URL = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
    SOCKET_URL = 'https://urmeet-io.worktual.co.uk';
    CHATBOT_URL = "https://botclient.worktual.co.uk";
    FACEBOOK_URL = "https://did.worktual.co.uk/fb";
    INSTAGRAM_URL = "https://did.worktual.co.uk/ig";
    UPLOAD_MEETING_FILES = "https://urapi.worktual.co.uk/urmeet/v1/files/upload_meetingfiles";
    CRM_URL = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1";
    CCAAS_WHATSAPP_URL = "https://ccaasapi.worktual.co.uk/whatsappService/v1";
    MYACCOUNT_PROFILE = "https://myaccount.worktual.co.uk/profile";
    WHATSAPP_CONF_URL = "https://did.worktual.co.uk/metawhatsapp";
    BUSINESS_WHATSAPP_CONF_URL = "https://did.worktual.co.uk/businesswhatsapp";
    APPOINTMENT_BOOKING_URL = "https://bookingapi.worktual.co.uk/booking_service/v1"
    BOT_SCRIPT_URL = "https://stageccaas.worktual.co.uk/worktual_widget.js"
    GET_ALL_TEMPLATES_URL = "https://did.worktual.co.uk/whatsapp/v1/wca/getTemplates";
    GET_TEMPLATE_URL = "https://did.worktual.co.uk/whatsapp/v1/wca/getTemplateByName";
    DASHBOARD_AISUMMARY_AGENTDASH = "https://nlp.worktual.co.uk/live_agent_dashboard_summary";
    DASHBOARD_AISUMMARY_AGENTDASH_RECOM = "https://nlp.worktual.co.uk/live_agent_dashboard_recommendation";
    DASHBOARD_AISUMMARY_MAINDASH = "https://nlp.worktual.co.uk/live_main_dashboard_summary";
    DASHBOARD_AISUMMARY_MAINDASH_RECOM = "https://nlp.worktual.co.uk/live_main_dashboard_recommendation";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH = "https://nlp.worktual.co.uk/outbound_callblast";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH_RECOM = "https://nlp.worktual.co.uk/outbound_recommendation";
    FACE_DETECTION = 'https://facedetect.worktual.co.uk/detect_face';
    FACE_UPLOAD_IMAGE = 'https://facedetect.worktual.co.uk/upload_images';
    FACE_RECOGNITION = 'https://facedetect.worktual.co.uk/return_result';
    DOC_UPLOAD_EXTRACT = 'https://facedetect.worktual.co.uk/upload_and_extract';
    DOC_VERIFICATION = 'https://facedetect.worktual.co.uk/verification';
    VERIFICATION_DELETE = 'https://facedetect.worktual.co.uk/delete';
    TTS = "https://nlp.worktual.co.uk/tts";
    PRIVIOUS_CHAT_SUMMARY = "https://scraping.worktual.co.uk/previous_chat_summary";
    AGENT_SUMMARIZE_CONVO = "https://nlp.worktual.co.uk/agent_summarize_convo";
  } else if (process.env.REACT_APP_ENV === "preproduction") {
    //APPID = "773040";
    //AppSECRET = "EEnQKXFm4A";
    APPID = "844239";
    AppSECRET = "kU9IPc0C65";
    BASE_URL = "https://preccaasapi.worktual.co.uk";
    //CORESERVICE_URL = "http://localhost:3002/core_service/v1";
    CORESERVICE_URL = "https://preccaasapi.worktual.co.uk/core_service/v1";
    SOCIALMEDIA_URL = "https://preccaasapi.worktual.co.uk/socialmediaService/v1";
    MEET_RESTAPI_URL = "https://preccaasapi.worktual.co.uk/core_service";
    //  LOGIN_API = "https://preccaasapi.worktual.co.uk/ccaasAuth/v1/token/create_jwt";
    EMAILSERVICE_URL = "https://preccaasapi.worktual.co.uk/emailService/v1";
    SMSSERVICE_URL = "https://preccaasapi.worktual.co.uk/smsService/v1";
    CALLSERVICE_URL = "https://preccaasapi.worktual.co.uk/callservice/v1";
    // CALLSERVICE_URL = "http://localhost:5007/callservice/v1";
    // REPORTSERVICE_URL = "http://localhost:5002/reports_service/v1";
    REPORTSERVICE_URL = "https://preccaasapi.worktual.co.uk/reports_service/v1";
    LIVECHATSERVICEURL = "https://stageurapi.unifiedring.co.uk/vectone-myaccount/v1/user";
    CALL_SERVER_WSS_URL = "wss://stageccaasaudiosgw.worktual.co.uk:57344";
    VIDEO_CALL_SERVER_WSS_URL = "wss://videosgwth.worktual.co.uk:57344";
    CALL_SERVER_STUN_URL = "turn:audioturnv4.worktual.co.uk:443";
    VIDEO_CALL_SERVER_STUN_URL = 'turn:audioturnv4.worktual.co.uk:3478';
    VIDEO_CALL_SERVER_STUN_URL_DDCL = "turn:audioturnv4ddcl.worktual.co.uk:3478";
    VIDEO_CALL_SERVER_STUN_URL_TH = "turn:audioturnv4th.worktual.co.uk:3478";
    VIDEO_CALL_SERVER_V6_STUN_URL = 'turn:audioturnv6.worktual.co.uk:3478';
    VIDEO_CALL_SERVER_V6_STUN_URL_DDCL = 'turn:audioturnv6ddcl.worktual.co.uk:3478';
    VIDEO_CALL_SERVER_V6_STUN_URL_TH = 'turn:audioturnv6th.worktual.co.uk:3478';
    MYACCOUNT = 'https://myaccount.worktual.co.uk'
    LOG_OUT_API = 'https://preurapi.worktual.co.uk/urauth/v1/token/logout'
    LOGIN_API = "https://preurapi.worktual.co.uk/urauth/v1/token/create_jwt";
    TICKETSERVICE_URL = "https://ticketingsystem.worktual.co.uk/ticketing-system/v1";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/myaccount-mysql/v1";
    BOT_URL = "https://botclient.worktual.co.uk";
    CONNECTORS_API_BASE_URL = 'https://preccaasapi.worktual.co.uk/connector'
    DEVELOPER_APP_BASE_URL = 'https://api.worktual.co.uk/services/v1'
    ZENDESK_SUPPORT_CLIENT_ID = "zdg-worktual_ucaas_for_zendesk_support"
    ZENDESK_SUPPORT_SCOPES = "tickets:read write users:read write organizations:write read"
    SMS_DID = "https://did.worktual.co.uk/did/v1";
    WHATSAPP_URL = "https://did.worktual.co.uk/whatsapp/v1";
    PRICING_URL = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
    SOCKET_URL = 'https://urmeet-io.worktual.co.uk';
    CHATBOT_URL = "https://botclient.worktual.co.uk";
    FACEBOOK_URL = "https://did.worktual.co.uk/fb";
    INSTAGRAM_URL = "https://did.worktual.co.uk/ig";
    UPLOAD_MEETING_FILES = "https://preurapi.worktual.co.uk/urmeet/v1/files/upload_meetingfiles";
    CRM_URL = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1";
    CCAAS_WHATSAPP_URL = "https://preccaasapi.worktual.co.uk/whatsappService/v1";
    MYACCOUNT_PROFILE = "https://myaccount.worktual.co.uk/profile";
    WHATSAPP_CONF_URL = "https://did.worktual.co.uk/metawhatsapp";
    BUSINESS_WHATSAPP_CONF_URL = "https://did.worktual.co.uk/businesswhatsapp";
    APPOINTMENT_BOOKING_URL = "https://bookingapi.worktual.co.uk/booking_service/v1"
    BOT_SCRIPT_URL = "https://stageccaas.worktual.co.uk/worktual_widget.js"
    GET_ALL_TEMPLATES_URL = "https://did.worktual.co.uk/whatsapp/v1/wca/getTemplates";
    GET_TEMPLATE_URL = "https://did.worktual.co.uk/whatsapp/v1/wca/getTemplateByName";
    DASHBOARD_AISUMMARY_AGENTDASH = "https://nlp.worktual.co.uk/live_agent_dashboard_summary";
    DASHBOARD_AISUMMARY_AGENTDASH_RECOM = "https://nlp.worktual.co.uk/live_agent_dashboard_recommendation";
    DASHBOARD_AISUMMARY_MAINDASH = "https://nlp.worktual.co.uk/live_main_dashboard_summary";
    DASHBOARD_AISUMMARY_MAINDASH_RECOM = "https://nlp.worktual.co.uk/live_main_dashboard_recommendation";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH = "https://nlp.worktual.co.uk/outbound_callblast";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH_RECOM = "https://nlp.worktual.co.uk/outbound_recommendation";
    FACE_DETECTION = 'https://facedetect.worktual.co.uk/detect_face';
    FACE_UPLOAD_IMAGE = 'https://facedetect.worktual.co.uk/upload_images';
    FACE_RECOGNITION = 'https://facedetect.worktual.co.uk/return_result';
    DOC_UPLOAD_EXTRACT = 'https://facedetect.worktual.co.uk/upload_and_extract';
    DOC_VERIFICATION = 'https://facedetect.worktual.co.uk/verification';
    VERIFICATION_DELETE = 'https://facedetect.worktual.co.uk/delete';
    TTS = "https://nlp.worktual.co.uk/tts";
    PRIVIOUS_CHAT_SUMMARY = "https://scraping.worktual.co.uk/previous_chat_summary";
    AGENT_SUMMARIZE_CONVO = "https://nlp.worktual.co.uk/agent_summarize_convo";
  } else if (process.env.REACT_APP_ENV === "umn") {
    APPID = "844239";
    AppSECRET = "kU9IPc0C65";
    BASE_URL = "https://stageqaccaasapi.worktual.co.uk";
    MEET_RESTAPI_URL = "https://stageqaccaasapi.worktual.co.uk/core_service";
    SOCIALMEDIA_URL = "https://stageqaccaasapi.worktual.co.uk/socialmediaService/v1";
    CORESERVICE_URL = "https://stageqaccaasapi.worktual.co.uk/core_service/v1";
    LOGIN_API = "https://qaurapi.worktual.co.uk/urauth/v1/token/create_jwt";
    CALLSERVICE_URL = "https://stageqaccaasapi.worktual.co.uk/callservice/v1";
    EMAILSERVICE_URL = "https://stageqaccaasapi.worktual.co.uk/emailService/v1"
    SMSSERVICE_URL = "https://stageqaccaasapi.worktual.co.uk/smsService/v1";
    REPORTSERVICE_URL = "https://stageqaccaasapi.worktual.co.uk/reports_service/v1";
    LIVECHATSERVICEURL = "https://stageurapi.unifiedring.co.uk/vectone-myaccount/v1/user";
    CALL_SERVER_WSS_URL = "wss://qaccaassgw.worktual.co.uk:57344";
    CALL_SERVER_STUN_URL = "turn:qaaudioturnv4.worktual.co.uk:443";
    VIDEO_CALL_SERVER_WSS_URL = "wss://qavideosgw.worktual.co.uk:57344";
    VIDEO_CALL_SERVER_STUN_URL = "turn:audioturnv4.worktual.co.uk:3478";
    MYACCOUNT = 'https://qa-myaccount.worktual.co.uk/';
    LOG_OUT_API = 'https://qaurapi.worktual.co.uk/urauth/v1/token/logout'
    BOT_URL = "https://qachatbot.worktual.co.uk";
    SOCKET_URL = 'https://stageqaccaasapi.worktual.co.uk'
    TICKETSERVICE_URL = "https://ticketingsystem.worktual.co.uk/ticketing-system/v1";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
    SMS_DID = "https://stagedid.worktual.co.uk/did/v1";
    WHATSAPP_URL = "https://stagedid.worktual.co.uk/whatsapp/v1";
    PRICING_URL = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
    CHATBOT_URL = "https://qachatbot.worktual.co.uk";
    FACEBOOK_URL = "https://stagedid.worktual.co.uk/fb";
    INSTAGRAM_URL = "https://stagedid.worktual.co.uk/ig";
    UPLOAD_MEETING_FILES = "https://qaurapi.worktual.co.uk/urmeet/v1/files/upload_meetingfiles";
    CRM_URL = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1/common/qa";
    CCAAS_WHATSAPP_URL = "https://stageqaccaasapi.worktual.co.uk/whatsappService/v1";
    MYACCOUNT_PROFILE = "https://qa-myaccount.worktual.co.uk/profile";
    WHATSAPP_CONF_URL = "https://stagedid.worktual.co.uk/metawhatsapp";
    BUSINESS_WHATSAPP_CONF_URL = "https://stagedid.worktual.co.uk/businesswhatsapp";
    APPOINTMENT_BOOKING_URL = "https://qabookingapi.worktual.co.uk/booking_service/v1"
    BOT_SCRIPT_URL = "https://qachatbot.worktual.co.uk/worktual_widget.js"
    GET_ALL_TEMPLATES_URL = "https://stagedid.worktual.co.uk/whatsapp/v1/wca/getTemplates";
    GET_TEMPLATE_URL = "https://stagedid.worktual.co.uk/whatsapp/v1/wca/getTemplateByName";
    DASHBOARD_AISUMMARY_AGENTDASH = "https://qaaichat.worktual.co.uk/qa_agent_dashboard";
    DASHBOARD_AISUMMARY_AGENTDASH_RECOM = "https://qaaichat.worktual.co.uk/qa_agent_dashboard_recommendation";
    DASHBOARD_AISUMMARY_MAINDASH = "https://qaaichat.worktual.co.uk/qa_main_dashboard";
    DASHBOARD_AISUMMARY_MAINDASH_RECOM = "https://qaaichat.worktual.co.uk/qa_main_dashboard_recommendation";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH = "https://nlp.worktual.co.uk/qa_outbound_callblast";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH_RECOM = "https://nlp.worktual.co.uk/qa_outbound_recommendation";
    TTS = "https://nlp.worktual.co.uk/tts";
    PRIVIOUS_CHAT_SUMMARY = "https://scraping.worktual.co.uk/previous_chat_summary";
  } else if (process.env.REACT_APP_ENV === "stage") {
    APPID = "844239";
    AppSECRET = "kU9IPc0C65";
    BASE_URL = "https://uatccaasapi.worktual.com";
    MEET_RESTAPI_URL = "https://uatccaasapi.worktual.com/core_service";
    SOCIALMEDIA_URL = "https://uatccaasapi.worktual.com/socialmediaService/v1";
    CORESERVICE_URL = "https://uatccaasapi.worktual.com/core_service/v1";
    LOGIN_API = "https://qaurapi.worktual.co.uk/urauth/v1/token/create_jwt";
    CALLSERVICE_URL = "https://uatccaasapi.worktual.com/callservice/v1";
    EMAILSERVICE_URL = "https://uatccaasapi.worktual.com/emailService/v1"
    SMSSERVICE_URL = "https://uatccaasapi.worktual.com/smsService/v1";
    REPORTSERVICE_URL = "https://uatccaasapi.worktual.com/reports_service/v1";
    LIVECHATSERVICEURL = "https://stageurapi.unifiedring.co.uk/vectone-myaccount/v1/user";
    CALL_SERVER_WSS_URL = "wss://qaccaassgw2.worktual.co.uk:57344";;
    CALL_SERVER_STUN_URL = "turn:audioturnv4.worktual.co.uk:3478";
    VIDEO_CALL_SERVER_WSS_URL = "wss://qavideosgw.worktual.co.uk:57344";
    VIDEO_CALL_SERVER_STUN_URL = "turn:videoturnv4.worktual.co.uk:3478";
    MYACCOUNT = 'https://qa-myaccount.worktual.co.uk/';
    LOG_OUT_API = 'https://qaurapi.worktual.co.uk/urauth/v1/token/logout'
    BOT_URL = "https://qachatbot.worktual.co.uk";
    SOCKET_URL = 'https://uatccaasapi.worktual.com'
    TICKETSERVICE_URL = "https://ticketingsystem.worktual.co.uk/ticketing-system/v1";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
    SMS_DID = "https://stagedid.worktual.co.uk/did/v1";
    WHATSAPP_URL = "https://stagedid.worktual.co.uk/whatsapp/v1";
    PRICING_URL = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
    CHATBOT_URL = "https://qachatbot.worktual.co.uk";
    FACEBOOK_URL = "https://stagedid.worktual.co.uk/fb";
    INSTAGRAM_URL = "https://stagedid.worktual.co.uk/ig";
    UPLOAD_MEETING_FILES = "https://qaurapi.worktual.co.uk/urmeet/v1/files/upload_meetingfiles";
    CRM_URL = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1/common/qa";
    CCAAS_WHATSAPP_URL = "https://uatccaasapi.worktual.com/whatsappService/v1";
    MYACCOUNT_PROFILE = "https://qa-myaccount.worktual.co.uk/profile";
    WHATSAPP_CONF_URL = "https://stagedid.worktual.co.uk/metawhatsapp";
    BUSINESS_WHATSAPP_CONF_URL = "https://stagedid.worktual.co.uk/businesswhatsapp";
    APPOINTMENT_BOOKING_URL = "https://qabookingapi.worktual.co.uk/booking_service/v1"
    BOT_SCRIPT_URL = "https://qachatbot.worktual.co.uk/worktual_widget.js"
    GET_ALL_TEMPLATES_URL = "https://stagedid.worktual.co.uk/whatsapp/v1/wca/getTemplates";
    GET_TEMPLATE_URL = "https://stagedid.worktual.co.uk/whatsapp/v1/wca/getTemplateByName";
    DASHBOARD_AISUMMARY_AGENTDASH = "https://qaaichat.worktual.co.uk/qa_agent_dashboard";
    DASHBOARD_AISUMMARY_AGENTDASH_RECOM = "https://qaaichat.worktual.co.uk/qa_agent_dashboard_recommendation";
    DASHBOARD_AISUMMARY_MAINDASH = "https://qaaichat.worktual.co.uk/qa_main_dashboard";
    DASHBOARD_AISUMMARY_MAINDASH_RECOM = "https://qaaichat.worktual.co.uk/qa_main_dashboard_recommendation";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH = "https://nlp.worktual.co.uk/qa_outbound_callblast";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH_RECOM = "https://nlp.worktual.co.uk/qa_outbound_recommendation";
    FACE_DETECTION = 'https://facedetect.worktual.co.uk/detect_face';
    FACE_UPLOAD_IMAGE = 'https://facedetect.worktual.co.uk/upload_images';
    FACE_RECOGNITION = 'https://facedetect.worktual.co.uk/return_result';
    DOC_UPLOAD_EXTRACT = 'https://facedetect.worktual.co.uk/upload_and_extract'
    DOC_VERIFICATION = 'https://facedetect.worktual.co.uk/verification'
    VERIFICATION_DELETE = 'https://facedetect.worktual.co.uk/delete'
    TTS = "https://nlp.worktual.co.uk/tts";
    PRIVIOUS_CHAT_SUMMARY = "https://scraping.worktual.co.uk/previous_chat_summary";
  } else {
    APPID = "844239";
    AppSECRET = "kU9IPc0C65";
    // BASE_URL = "http://localhost:5008";
    BASE_URL = "https://qaccaasapi.worktual.co.uk";
    MEET_RESTAPI_URL = "https://qaccaasapi.worktual.co.uk/core_service";
    // BASE_URL = "http://46.43.144.65:3002";
    // CORESERVICE_URL = "http://localhost:3002/core_service/v1";
    SOCIALMEDIA_URL = "https://qaccaasapi.worktual.co.uk/socialmediaService/v1";
    // CORESERVICE_URL = "http://localhost:3002/core_service/v1";
    CORESERVICE_URL = "https://qaccaasapi.worktual.co.uk/core_service/v1";
    // LOGIN_API = "https://qaccaasapi.worktual.co.uk/ccaasAuth/v1/token/create_jwt";
    // LOGIN_API = "https://qaccaasapi.worktual.co.uk/urauth/v1/token/create_jwt";
    // LOGIN_API = "http://localhost:5002/urauth/v1/token/create_jwt";
    LOGIN_API = "https://qaurapi.worktual.co.uk/urauth/v1/token/create_jwt";
    // LOGIN_API = "https://urapi.worktual.co.uk/urauth/v1/token/create_jwt";
    // CALLSERVICE_URL = "http://localhost:5007/callservice/v1";
    CALLSERVICE_URL = "https://qaccaasapi.worktual.co.uk/callservice/v1";
    EMAILSERVICE_URL = "https://qaccaasapi.worktual.co.uk/emailService/v1"
    SMSSERVICE_URL = "https://qaccaasapi.worktual.co.uk/smsService/v1";
    // REPORTSERVICE_URL = "http://localhost:5002/reports_service/v1";
    REPORTSERVICE_URL = "https://qaccaasapi.worktual.co.uk/reports_service/v1";
    LIVECHATSERVICEURL = "https://stageurapi.unifiedring.co.uk/vectone-myaccount/v1/user";
    //  CALL_SERVER_WSS_URL = "wss://audiosgw.worktual.co.uk:57344";
    CALL_SERVER_WSS_URL = "wss://qaccaasaudiosgw.worktual.co.uk:57344"; 
    CALL_SERVER_STUN_URL = "turn:qaaudioturnv4.worktual.co.uk:443";
    VIDEO_CALL_SERVER_WSS_URL = "wss://qavideosgw.worktual.co.uk:57344";
    VIDEO_CALL_SERVER_STUN_URL = "turn:audioturnv4.worktual.co.uk:3478";
    MYACCOUNT = 'https://qa-myaccount.worktual.co.uk/';
    LOG_OUT_API = 'https://qaurapi.worktual.co.uk/urauth/v1/token/logout'
    BOT_URL = "https://qachatbot.worktual.co.uk";
    // SOCKET_URL="https://qaurmeet-io.worktual.co.uk";
    //SOCKET_URL='http://localhost:8080';
    SOCKET_URL = 'https://qaccaasapi.worktual.co.uk'
    // LOG_OUT_API = 'https://qaccaasapi.worktual.co.uk/urauth/v1/token/logout'
    // LOG_OUT_API = 'https://qaurapi.worktual.co.uk/urauth/v1/token/logout'
    // LOG_OUT_API = 'https://urapi.worktual.co.uk/urauth/v1/token/logout'
    TICKETSERVICE_URL = "https://ticketingsystem.worktual.co.uk/ticketing-system/v1";
    MYACCOUNTSERVICE_URL = "https://mysqlapi.worktual.co.uk/qamyaccount-mysql/v1";
    SMS_DID = "https://stagedid.worktual.co.uk/did/v1";
    WHATSAPP_URL = "https://stagedid.worktual.co.uk/whatsapp/v1";
    PRICING_URL = "https://mysqlapi.worktual.co.uk/urpricing-mysql/v1";
    // SOCKET_URL = 'https://qaurmeet-io.worktual.co.uk';
    CHATBOT_URL = "https://qachatbot.worktual.co.uk";
    FACEBOOK_URL = "https://stagedid.worktual.co.uk/fb";
    INSTAGRAM_URL = "https://stagedid.worktual.co.uk/ig";
    UPLOAD_MEETING_FILES = "https://qaurapi.worktual.co.uk/urmeet/v1/files/upload_meetingfiles";
    CRM_URL = "https://stagemarketingapi.worktual.co.uk/marketing_automation/v1/common/qa";
    CCAAS_WHATSAPP_URL = "https://qaccaasapi.worktual.co.uk/whatsappService/v1";
    MYACCOUNT_PROFILE = "https://qa-myaccount.worktual.co.uk/profile";
    WHATSAPP_CONF_URL = "https://stagedid.worktual.co.uk/metawhatsapp";
    BUSINESS_WHATSAPP_CONF_URL = "https://stagedid.worktual.co.uk/businesswhatsapp";
    APPOINTMENT_BOOKING_URL = "https://qabookingapi.worktual.co.uk/booking_service/v1"
    BOT_SCRIPT_URL = "https://qachatbot.worktual.co.uk/worktual_widget.js"
    GET_ALL_TEMPLATES_URL = "https://stagedid.worktual.co.uk/whatsapp/v1/wca/getTemplates";
    GET_TEMPLATE_URL = "https://stagedid.worktual.co.uk/whatsapp/v1/wca/getTemplateByName";
    DASHBOARD_AISUMMARY_AGENTDASH = "https://qaaichat.worktual.co.uk/qa_agent_dashboard";
    DASHBOARD_AISUMMARY_AGENTDASH_RECOM = "https://qaaichat.worktual.co.uk/qa_agent_dashboard_recommendation";
    DASHBOARD_AISUMMARY_MAINDASH = "https://qaaichat.worktual.co.uk/qa_main_dashboard";
    DASHBOARD_AISUMMARY_MAINDASH_RECOM = "https://qaaichat.worktual.co.uk/qa_main_dashboard_recommendation";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH = "https://nlp.worktual.co.uk/qa_outbound_callblast";
    DASHBOARD_AISUMMARY_CAMPAIGNDASH_RECOM = "https://nlp.worktual.co.uk/qa_outbound_recommendation";
    FACE_DETECTION = 'https://facedetect.worktual.co.uk/detect_face';
    FACE_UPLOAD_IMAGE = 'https://facedetect.worktual.co.uk/upload_images';
    FACE_RECOGNITION = 'https://facedetect.worktual.co.uk/return_result';
    DOC_UPLOAD_EXTRACT = 'https://facedetect.worktual.co.uk/upload_and_extract'
    DOC_VERIFICATION = 'https://facedetect.worktual.co.uk/verification'
    VERIFICATION_DELETE = 'https://facedetect.worktual.co.uk/delete'
    TTS = "https://nlp.worktual.co.uk/tts";
    PRIVIOUS_CHAT_SUMMARY = "https://scraping.worktual.co.uk/previous_chat_summary";
  }

  return {
    APPID,
    AppSECRET,
    CALL_SERVER_WSS_URL,
    VIDEO_CALL_SERVER_WSS_URL,
    CALL_SERVER_USER_AGENT,
    VIDEO_SERVER_USER_AGENT,
    CALL_SERVER_STUN_URL,
    VIDEO_CALL_SERVER_STUN_URL,
    VIDEO_CALL_SERVER_STUN_URL_DDCL,
    VIDEO_CALL_SERVER_STUN_URL_TH,
    VIDEO_CALL_SERVER_V6_STUN_URL,
    VIDEO_CALL_SERVER_V6_STUN_URL_DDCL,
    VIDEO_CALL_SERVER_V6_STUN_URL_TH,
    VIDEO_CALL_SERVER_STUN_USERNAME,
    VIDEO_CALL_SERVER_STUN_PASSWORD,
    CALL_SERVER_STUN_USERNAME,
    CALL_SERVER_STUN_PASSWORD,
    CORESERVICE_URL,
    EMAILSERVICE_URL,
    SMSSERVICE_URL,
    CALLSERVICE_URL,
    REPORTSERVICE_URL,
    LOGIN_API,
    LIVECHATSERVICEURL,
    DOMAIN_NAME_PORT,
    BASE_URL,
    MEET_RESTAPI_URL,
    MYACCOUNT,
    LOG_OUT_API,
    TICKETSERVICE_URL,
    MYACCOUNTSERVICE_URL,
    BOT_URL,
    CONNECTORS_API_BASE_URL,
    DEVELOPER_APP_BASE_URL,
    ZENDESK_SUPPORT_CLIENT_ID,
    ZENDESK_SUPPORT_SCOPES,
    SMS_DID,
    WHATSAPP_URL,
    PRICING_URL,
    SOCKET_URL,
    CHATBOT_URL,
    SOCIALMEDIA_URL,
    FACEBOOK_URL,
    INSTAGRAM_URL,
    SHOPIFY_CLIENT_ID,
    CRM_URL,
    UPLOAD_MEETING_FILES,
    CCAAS_WHATSAPP_URL,
    MYACCOUNT_PROFILE,
    WHATSAPP_CONF_URL,
    BUSINESS_WHATSAPP_CONF_URL,
    APPOINTMENT_BOOKING_URL,
    BOT_SCRIPT_URL,
    FACEBOOK_CONFIG_ID,
    FACEBOOK_APP_ID,
    GET_ALL_TEMPLATES_URL,
    GET_TEMPLATE_URL,
    BOTH_TYPE_CONTACT_SYNC,
    DASHBOARD_AISUMMARY_AGENTDASH,
    DASHBOARD_AISUMMARY_AGENTDASH_RECOM,
    DASHBOARD_AISUMMARY_MAINDASH,
    DASHBOARD_AISUMMARY_MAINDASH_RECOM,
    DASHBOARD_AISUMMARY_CAMPAIGNDASH,
    DASHBOARD_AISUMMARY_CAMPAIGNDASH_RECOM,
    FACE_DETECTION,
    FACE_UPLOAD_IMAGE,
    FACE_RECOGNITION,
    DOC_UPLOAD_EXTRACT,
    DOC_VERIFICATION,
    VERIFICATION_DELETE,
    TTS,
    PRIVIOUS_CHAT_SUMMARY,
    AGENT_SUMMARIZE_CONVO,
    NLP_DNS
  };
};

export const ROLES = {
  OWNER_ROLE_ID: "1",
  SUB_OWNER_ROLE_ID: "2",
  ADMIN_ROLE_ID: "3",
  MEMBER_ROLE_ID: "4",
  SUPERVISOR_ROLE_ID: "5",
  AGENT_ROLE_ID: "6",
};

export const PRIVILLEGED_ROLES = [ROLES.OWNER_ROLE_ID, ROLES.SUB_OWNER_ROLE_ID, ROLES.ADMIN_ROLE_ID];

export const CHAT_BOX_PLAN_ID = {
  XAIA_1_FREE: 54,
  XAIA_2_FREE: 107,
  XAIA_2_PAID: 103,
  XAIA_3_FREE: 55,
  XAIA_3_PAID: 56,
  XAIA_4_PAID: 57
}

export const CONTACT_CENTRE_PLAN_ID = {
  "XAIA_1+": 32,
  "XAIA_2+": 141,
  "XAIA_3+": 33,
  "XAIA_4+": 42
}

export const PRODUCT_ID_AND_NAME: any = {
  0: "All", //For support address in email
  1: "AI Contact Center",
  15: "Chatbox",
  16: "Marketing Email",
  17: "Appointment Bookings"
}

// export const hassAccess = [19331, 18878, 19465, 19704]

export const restrictedDomainIds: any = {
  'Ogrelogic Solutions LLC': 19465,
  'Cinimini By Theatre Concepts': 18878,
  'Calvary Temple': [19726]
}

export const DOMAINID = ["19331", "19726"]
export const reportsRoutes = [
  '/reportsmain',
  '/queueanalytics',
  '/agentanalyticsmain',
  '/aibotanalytics',
  '/channelreports',
  '/agentreports',
  '/aibotreports',
  '/visitorinsights',
  '/sheduledreports',
  '/outboundcampaignreports'
]

export const settinRoutes = [
  '/settingspage',
  '/contactcenternumber',
  '/customqueue',
  '/routingprofile',
  '/businesshours',
  '/playprompt',
  '/skillmanagement',
  '/usermanagement',
  '/chatlimit',
  '/recordSetting',
  '/callconfig',
  '/webchatwidget',
  '/emailconfig',
  '/smsListTable',
  '/whatsappconfig',
  '/facebookconfig',
  '/instagramconfig',
  '/dispositionstatus',
  '/agentstatus',
  '/customertag',
  '/customertype',
  '/callblast',
  '/customersatisfaction',
  '/contactsettings',
  '/leadgenaration',
  '/conversationtrigger',
  '/connectors',
  '/apiconfiguration',
  '/apiintegration',
  '/oauthclient',
  '/privateapp',
  '/publicapp',
  '/paymentmethods',
  '/BusinessHours',
]

export const TYPE_ID = {
  agentKnowledgeBase: 2007001,
  customerKnowledgeBase: 2007002
}



export const getDynamicTitle = () => {
  try {
    let title = `Worktual {{title}} Login - AI Communication Platform`;
    if (window.location.host?.includes('lola')) {
      title = title.replace('{{title}}', 'Lola')
    } else if (window.location.host?.includes('luka')) {
      title = title.replace('{{title}}', 'Lukas')
    } else {
      title = title.replace('{{title}}', 'CCAAS')
    }
    return title;
  } catch (error) {
    console.log(error)
    return `Worktual CCAAS Login - AI Communication Platform`
  }
}

export const getDynamicLocation = () => {
  try {
    if (window.location.host?.includes('lola')) {
      return 'LOLA'
    } else if (window.location.host?.includes('luka')) {
      return 'LUKAS'
    } else {
      return 'CCAAS'
    }
  } catch (error) {
    console.log(error)
    return `CCAAS`
  }
}

export const getDynamicProductName = () => {
  try {
    if (window.location.host?.includes('lola')) {
       return 'Chatbot'
    } else if (window.location.host?.includes('luka')) {
        return 'Chatbot'
    }
    return 'contact centre'
  } catch (error) {
    console.log(error)
    return 'contact centre'
  }
}